export default __webpack_public_path__ + "static/media/smile-outline-light.baff17aa.svg";